'use client'

import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'
import { PlayVideoIcon } from '@repo/ui/PlayVideoIcon'
import { useDashboardVideoStore } from '@repo/store/useDashboardVideoStore'
import { AnnouncementsPanel } from '../AnnouncementsPanel/AnnouncementsPanel'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useWindowSize } from '@uidotdev/usehooks'
import { useEffect, useState } from 'react'

export const DashboardHeader = () => {
  const { toggleVideoModal } = useDashboardVideoStore()
  const { width: windowWidth } = useWindowSize()
  const { sidebarMode } = useGlobalSettingsStore()
  const [narrowMode, setNarrowMode] = useState(false)

  useEffect(() => {
    const breakpoint = sidebarMode === 'expanded' ? 1300 : 1100
    setNarrowMode(windowWidth < breakpoint)
  }, [windowWidth, sidebarMode])

  return (
    <MUIStack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      data-testid="DashboardHeader"
      sx={{
        backgroundColor: 'primary.dark',
        borderRadius: 1,
        borderTopLeftRadius: '36px',
        padding: '20px 50px',
        height: '220px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <MUIStack direction="column">
        <MUITypography variant="h1" sx={{ mb: 5, color: 'white' }}>
          Welcome
        </MUITypography>

        <MUIStack direction="row" alignItems="center" gap={2}>
          <MUIButton
            variant="contained"
            color="primary"
            sx={{
              color: 'primary.dark',
              backgroundColor: 'white',
              borderColor: 'white',
              '&:hover': {
                color: 'primary.dark',
                backgroundColor: 'white',
                borderColor: 'white'
              }
            }}
            endIcon={<PlayVideoIcon sx={{ color: '#2F4572' }} />}
            onClick={() => toggleVideoModal(true)}
          >
            {`What's new`}
          </MUIButton>
          {narrowMode ? null : (
            <MUIButton
              variant="outlined"
              color="primary"
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  borderColor: 'white',
                  color: 'white'
                }
              }}
              onClick={() =>
                window.open('https://support.ospreyapproach.com/contact-osprey-approach-support/', '_blank')
              }
            >
              Support
            </MUIButton>
          )}
        </MUIStack>
      </MUIStack>

      <MUIStack direction="column">
        <AnnouncementsPanel width={narrowMode ? '480px' : '600px'} />
      </MUIStack>
    </MUIStack>
  )
}
